module.exports = __webpack_public_path__ + "static/media/view test dept.77e51570.svg";